import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { addDate } from "keautils";
import { GuiaListMem } from "./listmem";
import { observeResource } from "kea-resource";
import * as globals from "app/resources/globals";


import { FiltroGuiaComponent } from "./filtro";

interface Props {
    permisos: models.Rol;
    filtro: models.FiltroGuia;
    onFiltroChange: (x: models.FiltroGuia) => void;
}


/**Listado de todas las guias */
class GuiasListNoRx extends React.PureComponent<Props> {
    constructor(props) {
        super(props);
        const now = new Date();
        this.state = {
            filtro: {
                FechaInicio: addDate(now, "days", -3),
            }
        };
    }
    private VerFiltroClienteOrigenEnConsultaGuias = (props: Props) => props.permisos.Guia.VerFiltroClienteOrigenEnConsultaGuias;
    private filtro = (props: Props) => props.filtro;


    private guias = createSelectorRx(this.filtro, filtro => {
        const obs = observeResource(resources.Guia.Query, filtro);
        return obs;
    });

    handleOnLimpiar = async () => {
        await this.props.onFiltroChange({ 
            IdSucursalStatus: undefined,
            EnSucursalOrigen: undefined,
            EnSucursalDestino: undefined,
            FechaInicio: undefined,
            FechaFinal: undefined,
            IdClienteDestino: undefined,
            IdClienteOrigen: undefined,
            Folio: "",
            StatusGuiaFacturacion: undefined,
            Status: undefined,
            CantPaquetes: undefined,
            CantSobres: undefined,
            FletePorCobrar: undefined,
            EntregaDomicilio: undefined,
            RecoleccionDomicilio: undefined,
            TipoAcuse: undefined,
            ImporteMayorCero: undefined,
            TipoSeguro: undefined,
            Limite: 100
        });        
    }

    render() {
        const guias = this.guias(this.props);
        const verFiltroClienteOrigen = this.VerFiltroClienteOrigenEnConsultaGuias(this.props);
        return (
            <div>
                <kea.Title titulo="Consulta de guías" onLimpiar={this.handleOnLimpiar} />

                <FiltroGuiaComponent value={this.filtro(this.props)} onChange={this.props.onFiltroChange} verClienteOrigen={verFiltroClienteOrigen} />
                <GuiaListMem value={guias} cookieKey="ConsultaGuias" />
            </div>
        )
    }
}

const GuiasLisRx = componentToRx(GuiasListNoRx);
const session = resources.User.SessionRx;
/**Listado de todas las guias */
export class GuiaList extends React.PureComponent {
    render() {
        return <GuiasLisRx
            permisos={resources.User.PermisoRx}
            filtro={globals.state.map(x => x.filtroGuias)}
            onFiltroChange={x => globals.setState({ filtroGuias: x })}
        />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/guias/list/list.tsx